import React from 'react';
import './Book.css';

export default function Book() {
  return (
    <div className="book-page">
      <section className="book__hero">
        <p className="section-label">Book a class</p>
        <h1 className="section-heading">View the schedule</h1>
        <p className="book__hero-sub">
          Browse upcoming classes and reserve your spot. New students are always welcome.
        </p>
      </section>
      <section className="book__embed">
        <iframe
          src="https://florium.studio/flourish/embed"
          title="Flourish Yoga Schedule"
          className="book__iframe"
          frameBorder="0"
          allow="payment"
        />
      </section>
    </div>
  );
}
